import { render } from "./CandidateGamification.vue?vue&type=template&id=29ba6742"
import script from "./CandidateGamification.vue?vue&type=script&lang=js"
export * from "./CandidateGamification.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__